import { render } from "./CadCursosAulas.vue?vue&type=template&id=8b2e98fe"
import script from "./CadCursosAulas.vue?vue&type=script&lang=js"
export * from "./CadCursosAulas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__